<template>
    <section class="checkout-section">
        <div class="section-header">
            <h2>{{ selectedDeliveryMethod.flyIn.title }}</h2>
        </div>
        <div class="section-row">
            <span class="section-row-description">{{ selectedDeliveryMethod.flyIn.description }}</span>
            <div class="vertical-tile-list">
                <delivery-option-tile
                    v-for="option in selectedDeliveryMethod.options"
                    :key="option.id"
                    :option="option"
                    :methodId="selectedDeliveryMethod.id"
                    :isInFlyin="true"
                />
            </div>
        </div>
    </section>
</template>

<script src="./delivery-option-tile-list.js"/>
